import {FilterConverter} from "../filter/FilterConverter";
import {FiltersStateInitializer} from "../defaultInitializer/FiltersStateInitializer";
import {getAPIGatewayDataFromParent, getExportResultsDataFromParent} from "../../handler/ParentDataHandler";
import {isINRegion, logOperationalMetric} from "../../util/CommonUtils";
import {convertToValidPackageState} from "../CommonUtils";
import {paginatedFetch} from "./PaginatedFetchUtil";

const metricProcessName = "SCC_PACKAGE_DOWNLOAD";
const MAX_EXPORT_ROWS = 250000;

export async function getExportResults(filters, stationCode, view, leg) {

    var initializedFilters = FiltersStateInitializer(filters, [])
    var finalList=[];
    const startTime = Date.now();
    const NUMBER_OF_MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;
    let totalRowCount = 0;

    const apiCaller = isINRegion() ? getExportResultsDataFromParent : getAPIGatewayDataFromParent;

    for (let status of initializedFilters.packageStatuses) {
        var packageStatusMap = {}
        let from = 0;
        let modifiedRequest = await FilterConverter(initializedFilters, view, leg, packageStatusMap, status);
        var lastUpdatedRange;
        if (initializedFilters.lastUpdatedStart !== "" || initializedFilters.lastUpdatedEnd !== "") {
            lastUpdatedRange = {
            "startTime" : initializedFilters.lastUpdatedStart ? new Date(initializedFilters.lastUpdatedStart).getTime() / 1000 : (new Date(initializedFilters.lastUpdatedEnd).getTime() - NUMBER_OF_MILLISECONDS_IN_DAY) / 1000 ,
            "endTime": initializedFilters.lastUpdatedEnd ? new Date(initializedFilters.lastUpdatedEnd).getTime() / 1000 : (new Date(initializedFilters.lastUpdatedStart).getTime() + NUMBER_OF_MILLISECONDS_IN_DAY) / 1000
            }
        }

        const baseRequestBody = {
            "nodeId": stationCode,
            "packageStatusMap": packageStatusMap,
            "filters": modifiedRequest,
            "lastUpdatedRange": lastUpdatedRange,
            "size": 10000
        };

        try {
            const { results, totalRowCount: batchTotal } = await paginatedFetch(baseRequestBody, apiCaller, {
                transformFn: convertToValidPackageState,
                startingIndex: from,
                maxRows: MAX_EXPORT_ROWS - totalRowCount
            });

            if (results === null) {
                logOperationalMetric(startTime, metricProcessName, "getDrillDownData", false);
                return [];
            }

            finalList.push.apply(finalList, results);
            totalRowCount += batchTotal;
            logOperationalMetric(startTime, metricProcessName, "getDrillDownData", true);
        } catch (error) {
            return [];
        }

        if (totalRowCount >= MAX_EXPORT_ROWS) {
            break;
        }
    }

    return finalList;
}



// WEBPACK FOOTER //
// ./src/commons/api/GetExportResults.js